import type { ActionCreatorWithPayload } from '@reduxjs/toolkit';
import { createAction } from '@reduxjs/toolkit';

import type { EventType } from '@polyai/stream/commands/types';
import { updateDefaultLanguage } from '@polyai/stream/store/reducers/languages/actions';

// We can use this in case an event has no command handler, this is the case for branch events
const EVENT_TO_ACTION_OVERRIDES: Partial<
  // biome-ignore lint/suspicious/noExplicitAny: Custom mapping requires flexible typing
  Record<EventType, ActionCreatorWithPayload<any>>
> = {
  branchCreated: createAction('branchCreated'),
  branchDeleted: createAction('branchDeleted'),
  branchMerged: createAction('branchMerged'),
  deploymentCompleted: createAction('deploymentCompleted'),
  updateTtsSettings: updateDefaultLanguage,
};

export default EVENT_TO_ACTION_OVERRIDES;
